import { StoreyEntity } from './storey-entity.model';
import { WallSegment } from './wall-segment.model';

export abstract class Opening extends StoreyEntity {
    wallSegment: WallSegment;
    width = 1500;
    height = 1500;
}
